import {
    type DashboardExportState,
    getDashboardExportState
} from '@/lib/dashboards-api';
import { relativeTime } from '@/lib/relativeTime';
import useSWR from 'swr';

export function useDashboardExportState(dashboardId: string, enabled = true) {
    return useSWR(
        enabled ? ['dashboard-export-state', dashboardId] : null,
        ([, id]) => getDashboardExportState(id),
        { revalidateOnFocus: false, shouldRetryOnError: false }
    );
}

export function exportedSummary(state?: DashboardExportState) {
    if (!state || state.version < 1) return null;
    const when = state.publishedAt ? relativeTime(state.publishedAt) : '';
    return when
        ? `In BIG as version ${state.version} · ${when}`
        : `In BIG as version ${state.version}`;
}
